import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Button, Form, InputGroup, Spinner, Table } from 'react-bootstrap';
import { api } from '../../lib/api';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import Paginacao from '../../components/Paginacao';
import { COR_STATUS, STATUS, dataHora, resumoPedido } from './rotulos';

export default function ListaPedidos() {
  const toast = useToast();
  const { usuario } = useAuth();
  const [status, setStatus] = useState('aberto');
  const [busca, setBusca] = useState('');
  const [q, setQ] = useState('');
  const [pedidos, setPedidos] = useState(null);
  const [meta, setMeta] = useState(null);
  const [pagina, setPagina] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [erro, setErro] = useState(false);
  const mostraCorretor = usuario.nivel <= 2; // o corretor só vê os próprios: a coluna seria sempre ele mesmo

  useEffect(() => {
    let cancelado = false;
    setErro(false);
    const query = new URLSearchParams({ page: pagina, per_page: perPage, ...(status ? { status } : {}), ...(q ? { q } : {}) });
    api
      .get(`/pedidos?${query}`)
      .then((r) => {
        if (cancelado) return;
        setPedidos(r.data);
        setMeta(r.meta);
      })
      .catch((err) => {
        if (!cancelado) {
          setErro(true);
          toast.erro(err.message || 'Não foi possível carregar os pedidos');
        }
      });
    return () => {
      cancelado = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagina, perPage, status, q]);

  function buscar(e) {
    e.preventDefault();
    setQ(busca.trim());
    setPagina(1);
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
        <h1 className="h4 mb-0">Pedidos</h1>
        {usuario.permissoes?.pedidos_criar === true && (
          <Button as={Link} to="/pedidos/novo" variant="primary">
            Novo pedido
          </Button>
        )}
      </div>

      <Form onSubmit={buscar} className="d-flex flex-wrap gap-2 mb-3">
        <Form.Select value={status} onChange={(e) => { setStatus(e.target.value); setPagina(1); }} style={{ maxWidth: 200 }} aria-label="Situação do pedido">
          <option value="">Todas as situações</option>
          {STATUS.map(([k, r]) => <option key={k} value={k}>{r}</option>)}
        </Form.Select>
        <InputGroup style={{ maxWidth: 420 }}>
          <Form.Control value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="Buscar por nome, telefone, e-mail, bairro ou observação" aria-label="Buscar pedidos" />
          <Button type="submit" variant="outline-secondary">Buscar</Button>
        </InputGroup>
      </Form>

      {!pedidos && !erro && <Spinner animation="border" />}

      {pedidos && (
        <>
          <Table hover responsive>
            <thead>
              <tr>
                <th>Cliente</th>
                <th>O que procura</th>
                {mostraCorretor && <th>Corretor</th>}
                <th>Situação</th>
                <th>Cadastrado</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {pedidos.map((p) => (
                <tr key={p.public_id}>
                  <td>
                    <div className="fw-semibold">{p.nome}</div>
                    <div className="small text-muted">{p.telefone || p.email}</div>
                  </td>
                  <td>{resumoPedido(p)}</td>
                  {mostraCorretor && <td>{p.corretor}</td>}
                  <td><Badge bg={COR_STATUS[p.status] || 'secondary'}>{(STATUS.find(([k]) => k === p.status) || [])[1] || p.status}</Badge></td>
                  <td className="small">{dataHora(p.criadoEm)}</td>
                  <td className="text-end">
                    <Button as={Link} to={`/pedidos/${p.public_id}`} size="sm" variant="outline-secondary">Abrir</Button>
                  </td>
                </tr>
              ))}
              {pedidos.length === 0 && (
                <tr>
                  <td colSpan={mostraCorretor ? 6 : 5} className="text-muted">
                    {q || status ? 'Nenhum pedido encontrado com esses filtros.' : 'Nenhum pedido cadastrado ainda.'}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <Paginacao meta={meta} aoMudarPagina={setPagina} aoMudarPerPage={(n) => { setPerPage(n); setPagina(1); }} />
        </>
      )}
    </>
  );
}
